import { defineStore } from 'pinia';
import { ref, watch } from 'vue';
import { KeepAwake } from '@capacitor-community/keep-awake';

export const useExperiencePlayerStore = defineStore('experiencePlayer', () => {
  const isPaused = ref<boolean>(false);

  const pause = () => {
    isPaused.value = true;
  };

  const play = () => {
    isPaused.value = false;
  };

  watch(() => isPaused.value, (value) => {
    if (value) {
      KeepAwake.allowSleep();
    } else {
      KeepAwake.keepAwake();
    }
  });

  return {
    isPaused,
    pause,
    play,
  };
});
